import { CommentItemData, EventCardInfo, EventData, EventFullData, EventType } from "../types";
import { PieDiagramDataItem } from "./statistics";

export const defPageSize = 5;

export const statusNames = [
  {
    id: 1,
    name: "Запланировано"
  },
  {
    id: 2,
    name: "Обработано"
  },
  {
    id: 3,
    name: "Выполнено"
  }
]

export const statusNamesArr = [
  "Просрочено", "Запланировано", "Обработано", "Выполнено"
]

export const pieTestData: PieDiagramDataItem[] = [
  { label: "Регистрация", value: 1, color: "#FFA902", type_ids: [1] },
  { label: "Звонок", value: 1, color: "#E55000", type_ids: [2] },
  { label: "Консультация", value: 1, color: "#cfe745", type_ids: [3] },
  { label: "Практика", value: 10, color: "#FFD902", type_ids: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { label: "Вопрос о счете", value: 1, color: "#3AA8EF", type_ids: [14] },
  { label: "В поиске", value: 1, color: "#30C6F6", type_ids: [15] },
  { label: "Открытие счёта", value: 1, color: "#56D0E1", type_ids: [16] },
  { label: "Последующее пополнение", value: 1, color: "#BCFF02", type_ids: [17] },
  { label: "Мастер класс", value: 1, color: "#8A2BE2", type_ids: [18] },
  { label: "Встреча", value: 1, color: "#FF6347", type_ids: [19] },
  { label: "Собеседование на менеджера", value: 1, color: "#4682B4", type_ids: [20] },
  { label: "Собеседование на оператора", value: 1, color: "#5F9EA0", type_ids: [21] },
  { label: "Стажировка менеджеров", value: 1, color: "#D2691E", type_ids: [22] },
  { label: "Стажировка операторов", value: 1, color: "#6495ED", type_ids: [23] },
  { label: "Практики", value: 1, color: "#FFD700", type_ids: [24] },
  { label: "Лекция", value: 1, color: "#41a1ff", type_ids: [25] },
  { label: "Сервис", value: 1, color: "#743ad1", type_ids: [26] }
]

export const pieTestDataSplitPractice: PieDiagramDataItem[] = [
  { label: "Регистрация", value: 1, color: "#FFA902", type_ids: [1] },
  { label: "Звонок", value: 1, color: "#E55000", type_ids: [2] },
  { label: "Консультация", value: 1, color: "#cfe745", type_ids: [3] },
  { label: "Практика 1", value: 1, color: "#FF4500", type_ids: [4] },  // OrangeRed
  { label: "Практика 2", value: 1, color: "#FF6347", type_ids: [5] },  // Tomato
  { label: "Практика 3", value: 1, color: "#FF7F50", type_ids: [6] },  // Coral
  { label: "Практика 4", value: 1, color: "#FF8C00", type_ids: [7] },  // DarkOrange
  { label: "Практика 5", value: 1, color: "#FFA500", type_ids: [8] },  // Orange
  { label: "Практика 6", value: 1, color: "#FFD700", type_ids: [9] },  // Gold
  { label: "Практика 7", value: 1, color: "#FF0000", type_ids: [10] }, // Red
  { label: "Практика 8", value: 1, color: "#CD5C5C", type_ids: [11] }, // IndianRed
  { label: "Практика 9", value: 1, color: "#DC143C", type_ids: [12] }, // Crimson
  { label: "Практика 10", value: 1, color: "#B22222", type_ids: [13] }, // FireBrick
  { label: "Вопрос о счете", value: 1, color: "#3AA8EF", type_ids: [14] },
  { label: "В поиске", value: 1, color: "#30C6F6", type_ids: [15] },
  { label: "Открытие счёта", value: 1, color: "#56D0E1", type_ids: [16] },
  { label: "Последующее пополнение", value: 1, color: "#BCFF02", type_ids: [17] },
  { label: "Мастер класс", value: 1, color: "#8A2BE2", type_ids: [18] },
  { label: "Встреча", value: 1, color: "#FF6347", type_ids: [19] },
  { label: "Собеседование на менеджера", value: 1, color: "#4682B4", type_ids: [20] },
  { label: "Собеседование на оператора", value: 1, color: "#5F9EA0", type_ids: [21] },
  { label: "Стажировка менеджеров", value: 1, color: "#D2691E", type_ids: [22] },
  { label: "Стажировка операторов", value: 1, color: "#6495ED", type_ids: [23] },
  { label: "Лекция", value: 1, color: "#41a1ff", type_ids: [25] },
  { label: "Сервис", value: 1, color: "#743ad1", type_ids: [26] },
  { label: "Практики", value: 1, color: "#FFD700", type_ids: [24] }
];

export const currencies = [
  {
    id: 1,
    name: "Рубль",
    short: "RUB",
    symbol: "$"
  },
  {
    id: 2,
    name: "Доллар",
    short: "USD",
    symbol: "$"
  }
]